// extracted by mini-css-extract-plugin
export var box = "ThreeBoxRow-module--box--61eab";
export var boxRow = "ThreeBoxRow-module--boxRow--8c7f6";
export var box_imgWrap = "ThreeBoxRow-module--box_imgWrap--7645a";
export var box_text = "ThreeBoxRow-module--box_text--158ac";
export var overlayingBoxes = "ThreeBoxRow-module--overlayingBoxes--6de29";